import { useState, useEffect, useCallback } from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';
import Constants from 'expo-constants';

const STORAGE_KEY = 'whatsNewLastSeen';
const CURRENT_VERSION = Constants.expoConfig?.version ?? '0.0.0';

// Add an entry here for each release that has new features to announce.
// The modal appears once per version, then never again until the version changes.
export const WHATS_NEW_BY_VERSION = {
  '1.9.0': [
    {
      icon: 'map-marker-path',
      title: 'Meilleur suivi des trajets',
      description:
        "Itinéraire sur la carte, heure d'arrivée estimée et distance restante. Le lien de partage s'ouvre pour tout le monde, sans compte.",
    },
    {
      icon: 'coffee-outline',
      title: 'Pauses des conducteurs',
      description:
        "Signalez une pause et l'arrivée estimée s'ajuste. Votre trajet en cours est accessible d'un clic depuis n'importe quel écran.",
    },
    {
      icon: 'clipboard-check-outline',
      title: 'Inscriptions plus claires',
      description:
        "Si vous ne pouvez pas vous inscrire, l'application explique pourquoi : documents, cotisation, caution, poids…",
    },
    {
      icon: 'file-document-multiple-outline',
      title: 'Documents',
      description:
        'Documents obligatoires et facultatifs comptés séparément. Les conducteurs ont de nouveaux documents à fournir.',
    },
  ],
  '1.8.1': [
    {
      icon: 'rocket-launch',
      title: 'Nouveaux documents requis',
      description:
        'La Convention d\'engagement des compétiteurs devient obligatoire pour devenir compétiteur.',
    },
  ],
  '1.7.0': [
    {
      icon: 'incognito',
      title: "Jeu de l'Imposteur",
      description:
        'Un mot secret, un imposteur à démasquer. Jouez en local, entre amis ou à distance avec chat et messages vocaux.',
    },
  ],
};

export default function useWhatsNew() {
  const [shouldShow, setShouldShow] = useState(false);

  useEffect(() => {
    (async () => {
      const features = WHATS_NEW_BY_VERSION[CURRENT_VERSION];
      if (!features?.length) return;

      const lastSeen = await AsyncStorage.getItem(STORAGE_KEY);
      if (lastSeen !== CURRENT_VERSION) {
        setShouldShow(true);
      }
    })();
  }, []);

  const dismiss = useCallback(async () => {
    setShouldShow(false);
    await AsyncStorage.setItem(STORAGE_KEY, CURRENT_VERSION);
  }, []);

  return {
    shouldShow,
    dismiss,
    features: WHATS_NEW_BY_VERSION[CURRENT_VERSION] ?? [],
    version: CURRENT_VERSION,
  };
}
